<template>
  <div>
    <CompanyProfile />
  </div>
</template>

<script>
import CompanyProfile from '@/nfmp_components/AccountProfile.vue'
export default {
  components: {
    CompanyProfile
  }
}
</script>